import angular from 'angular';
import { makeSyncHttpRequest } from 'data/function';
import { MFEsConfigs } from '../config/MFEsConfigs';

const now = new Date();

export const settings = makeSyncHttpRequest('/settings.json?nocache=' + now.getTime(), 'GET');

let mfesSettings;
try {
    mfesSettings = makeSyncHttpRequest(`${settings.mfesSettingsSource}?nocache=` + now.getTime(), 'GET');
}
catch (_) {
    mfesSettings = {};
}

export const mfesConfigs = new MFEsConfigs(mfesSettings, settings);

export const
    blipAccountUrl = settings.blipAccountUrl,
    blipAccountClientId = settings.blipAccountClientId,
    blipLoginUrl = settings.blipLoginUrl,
    blipLoginClientId = settings.blipLoginClientId,
    accountManagementUrl = settings.accountManagementUrl,
    accountManagementAuthentication = settings.accountManagementAuthentication,
    blipAccountToggleDefaultValue = settings.blipAccountToggleDefaultValue,
    nodeEnv = settings.nodeEnv,
    portalDomain = settings.portalDomain,
    releaseNumber = settings.releaseNumber,
    defaultFragmentPrefix = settings.defaultFragmentPrefix,
    ldclientSdkKey = settings.ldclientSdkKey,
    proxyBaseUrl = settings.proxyBaseUrl,
    ldProxyBaseUrl = settings.ldProxyBaseUrl,
    ldProxyEventsUrl = settings.ldProxyEventsUrl,
    ldProxyClientStream = settings.ldProxyClientStream,
    ldStreamReconnectDelay = settings.ldStreamReconnectDelay,
    appInsightsInstrumentationKey = settings.appInsightsInstrumentationKey,
    appInsightsCloudComponentName = settings.appInsightsCloudComponentName,
    sugarAdsUrl = settings.sugarAdsUrl,
    facebookGraphBaseUrl = settings.facebookGraphBaseUrl,
    sentryDsn = settings.sentryDsn,
    commandTimeout = settings.commandTimeout,
    shouldRemoveAccountExtrasFromAuthentication = settings.shouldRemoveAccountExtrasFromAuthentication,
    hubspotSubmitFormsUrl = settings.hubspotSubmitFormsUrl,
    upgradePlanHubspotFormId = settings.upgradePlanHubspotFormId,
    hubspotPortalId = settings.hubspotPortalId,
    upgradePlanWppContact = settings.upgradePlanWppContact,
    cdpSettingsSource = mfesConfigs.cdp.uncachedSettingsURI,
    cdpScriptSource = mfesConfigs.cdp.uncachedScriptURI,
    analyticsSettingsSource = mfesConfigs.analytics.uncachedSettingsURI,
    analyticsScriptSource = mfesConfigs.analytics.uncachedScriptURI,
    goodDataSettingsSource = mfesConfigs.gooddata.uncachedSettingsURI,
    goodDataScriptSource = mfesConfigs.gooddata.uncachedScriptURI,
    aiSettingsSource = mfesConfigs.ai.uncachedSettingsURI,
    blipAiAssistantApi = settings.blipAiAssistantApi,
    blipStoreSettingsSource = mfesConfigs.blipStore.uncachedSettingsURI,
    blipStoreScriptSource = mfesConfigs.blipStore.uncachedScriptURI,
    blipInsightsSettingsSource = mfesConfigs.blipInsights.uncachedSettingsURI,
    blipInsightsScriptSource = mfesConfigs.blipInsights.uncachedScriptURI,
    blipSupportSettingsSource = mfesConfigs.blipSupport.uncachedSettingsURI,
    blipSupportScriptSource = mfesConfigs.blipSupport.uncachedScriptURI,
    blipStatusSettingsSource = mfesConfigs.blipStatus.uncachedSettingsURI,
    blipStatusScriptSource = mfesConfigs.blipStatus.uncachedScriptURI,
    blipPaymentsSettingsSource = mfesConfigs.blipPayments.uncachedSettingsURI,
    blipPaymentsScriptSource = mfesConfigs.blipPayments.uncachedScriptURI,
    blipConversationsInsightsSettingsSource = mfesConfigs.blipConversationsInsights.uncachedSettingsURI,
    blipConversationsInsightsScriptSource = mfesConfigs.blipConversationsInsights.uncachedScriptURI,
    onboardingSettingsSource = mfesConfigs.onboarding.uncachedSettingsURI,
    onboardingScriptSource = mfesConfigs.onboarding.uncachedScriptURI,
    channelsGbmScriptSource = mfesConfigs.channelsGbm.uncachedScriptURI,
    channelsMessengerScriptSource = mfesConfigs.channelsMessenger.uncachedScriptURI,
    channelsWhatsAppScriptSource = mfesConfigs.channelsWhatsApp.uncachedScriptURI,
    deskScriptSource = mfesConfigs.desk.uncachedScriptURI,
    deskSettingsSource = mfesConfigs.desk.uncachedSettingsURI,
    blipCopilotScriptSource = mfesConfigs.blipCopilot.uncachedScriptURI,
    blipCopilotSettingsSource = mfesConfigs.blipCopilot.uncachedSettingsURI,
    aiAgentsScriptSource = mfesConfigs.aiAgents.uncachedScriptURI,
    aiAgentsSettingsSource = mfesConfigs.aiAgents.uncachedSettingsURI,
    builderObservabilityScriptSource = mfesConfigs.builderObservability.uncachedScriptURI,
    builderObservabilitySettingsSource = mfesConfigs.builderObservability.uncachedSettingsURI,
    clickTrackerMfeScriptSource = mfesConfigs.clicktracker.uncachedScriptURI,
    clickTrackerSettingsSource = mfesConfigs.clicktracker.uncachedSettingsURI,
    adsBuyingMfeScriptSource = mfesConfigs.adsbuying.uncachedScriptURI,
    adsBuyingSettingsSource = mfesConfigs.adsbuying.uncachedSettingsURI,
    journeyMfeScriptSource = mfesConfigs.journey.uncachedScriptURI,
    journeySettingsSource = mfesConfigs.journey.uncachedSettingsURI,
    activeCampaignMfeScriptSource = mfesConfigs.activeCampaign.uncachedScriptURI,
    activeCampaignMfeSettingsSource = mfesConfigs.activeCampaign.uncachedSettingsURI,
    portalFragmentPermissionGroupsSettingsSource = mfesConfigs.portalFragmentPermissionGroups.uncachedSettingsURI,
    portalFragmentPermissionGroupsScriptSource = mfesConfigs.portalFragmentPermissionGroups.uncachedScriptURI,
    blipDomainUrl = settings.blipDomainUrl,
    blipWebsocketHostName = settings.blipWebsocketHostName,
    blipWebsocketHostNameTenant = settings.blipWebsocketHostNameTenant,
    blipHelpcenterUrl = 'https://help.blip.ai/',
    blipForumUrl = 'https://community.blip.ai/',
    blipProductUpdatesUrl = 'https://www.blip.ai/blog/product-updates/',
    tenantRoute = '/application/tenant/',
    dateToCompareTenant = settings.dateToCompareTenant,
    monitoringScreenRefreshPageTimeout = settings.monitoringScreenRefreshPageTimeout,
    monitoringScreenManualRefreshPageInterval = settings.monitoringScreenManualRefreshPageInterval,
    messaginghubWebsocketHostNameTenant = settings.messaginghubWebsocketHostNameTenant,
    messagingHubDomain = settings.messagingHubDomain,
    messaginghubWebsocketHostName = settings.messaginghubWebsocketHostName,
    messaginghubWebsocketPort = settings.messaginghubWebsocketPort,
    messaginghubWebsocketScheme = settings.messaginghubWebsocketScheme,
    blipAccountIssuer = settings.blipAccountIssuer,
    blipAzureIssuer = settings.blipAzureIssuer,
    blipDomain = settings.blipDomain,
    widgetHelpCenterUri = settings.widgetHelpCenterUri,
    widgetHelpCenterKey = settings.widgetHelpCenterKey,
    smartSalesApiUrl = settings.smartSalesApiUrl,
    smartSalesPortalUrl = settings.smartSalesPortalUrl,
    blipAiSuiteUrl = settings.blipAiSuiteUrl,
    advancedConfigurationFilteredOwners = settings.advancedConfigurationFilteredOwners,
    transcriptionSettingsSource = mfesConfigs.TRANSCRIPTION.uncachedSettingsURI,
    transcriptionScriptSource = mfesConfigs.TRANSCRIPTION.uncachedScriptURI,
    defaultClusterName = settings.defaultClusterName,
    BlipPortalUri = settings.BlipPortalUri,
    blipCallsTermsOfUseUrl = settings.blipCallsTermsOfUseUrl,
    personalTenantEnabled = settings.personalTenantEnabled,
    aiAgentIdentitySingleAction = settings.aiAgentIdentitySingleAction,
    aiAgentStilingueApiHost = settings.aiAgentStilingueApiHost,
    brainBotId = settings.brainBotId,
    aiAgentStilingueApiEnvironment = settings.aiAgentStilingueApiEnvironment,
    shouldCheckAiAgentPlan = settings.shouldCheckAiAgentPlan,
    agentProviders = settings.agentProviders,
    currentAiAgentsVersion = settings.currentAiAgentsVersion;

const module = angular
    .module('app.constants', []);
(() => {
    const constants = {
        'NG_TRANSLATE_LANG_KEY': 'NG_TRANSLATE_LANG_KEY',
        'MESSAGINGHUBDOMAIN': settings.messagingHubDomain,
        'PORTALDOMAIN': settings.portalDomain,
        'BLIP_DOMAIN': settings.blipDomain,
        'BLIP_ACCOUNT_URL': settings.blipAccountUrl,
        'BLIP_ACCOUNT_CLIENT_ID': settings.blipAccountClientId,
        'BLIP_LOGIN_URL': settings.blipLoginUrl,
        'BLIP_LOGIN_CLIENT_ID': settings.blipLoginClientId,
        'ACCOUNT_MANAGEMENTE_URL': settings.accountManagementUrl,
        'ACCOUNT_MANAGEMENT_AUTHENTICATION': settings.accountManagementAuthentication,
        'BLIP_ACCOUNT_ISSUER': settings.blipAccountIssuer,
        'BLIP_AZURE_ISSUER': settings.blipAzureIssuer,
        'MESSAGINGHUBWEBHOOKBASEURI': settings.messaginghubWebhookBaseUri,
        'MESSAGINGHUBHTTPHOSTNAME': settings.messaginghubHttpHostName,
        'MESSAGINGHUBHTTPHOSTNAMETENANT': settings.messaginghubHttpHostNameTenant,
        'MESSAGINGHUBWEBSOCKETHOSTNAME': settings.messaginghubWebsocketHostName,
        'MESSAGINGHUBWEBSOCKETHOSTNAMETENANT': settings.messaginghubWebsocketHostNameTenant,
        'MESSAGINGHUBTCPHOSTNAME': settings.messaginghubTcpHostName,
        'MESSAGINGHUBTCPHOSTNAMETENANT': settings.messaginghubTcpHostNameTenant,
        'MESSAGINGHUBWEBSOCKETPORT': settings.messaginghubWebsocketPort,
        'MESSAGINGHUBWEBSOCKETSCHEME': settings.messaginghubWebsocketScheme,
        'OMNI_DOMAIN': settings.omniDomain,
        'OMNI_WEBSOCKET_HOSTNAME': settings.omniWebsocketHostName,
        'OMNI_WEBSOCKET_HOSTNAME_TENANT': settings.omniWebsocketHostNameTenant,
        'BLIP_WEBSOCKET_HOSTNAME': settings.blipWebsocketHostName,
        'BLIP_WEBSOCKET_HOSTNAME_TENANT': settings.blipWebsocketHostNameTenant,
        'BLIP_WEBSOCKET_PORT': settings.blipWebsocketPort,
        'BLIP_WEBSOCKET_SCHEME': settings.blipWebsocketScheme,
        'MESSAGINGHUBGATEWAYSBASEURI': settings.messaginghubGatewaysBaseUri,
        'OMNIURI': settings.omniUri,
        'WORKPLACE_AUTH_URL': settings.workplaceAuthUrl,
        'WORKPLACE_AUTH_PERMISSIONS': settings.workplaceAuthPermissions,
        'MESSENGER_AUTH_PERMISSIONS': settings.messengerAuthPermissions,
        'INSTAGRAM_AUTH_PERMISSIONS': settings.instagramAuthPermissions,
        'WHATSAPP_AUTH_PERMISSIONS': settings.whatsAppAuthPermissions,
        'MARKETING_MESSAGES_LITE_API_CONFIGID': settings.marketingMessagesLiteApiConfigId,
        'MAILGUNDOMAIN': settings.mailgunDomain,
        'BLIPWEBURI': settings.blipWebUri,
        'GITHUB_TOKEN': settings.githubToken,
        'BLIPWEBSDK': settings.blipSdkUrl,
        'BLIPCHATURI': settings.blipChatUri,
        'BLIPCHATURITENANT': settings.blipChatUriTenant,
        'BLIPCHATWIDGETURI': settings.blipChatWidgetUri,
        'BLIPSDKEXAMPLEURI': settings.blipSdkExampleUri,
        'BLIPCHATEXAMPLEURI': settings.blipChatExampleUri,
        'DOCS_BRANCH': settings.docsBranch,
        'DOCS_URI': settings.docsUri,
        'DISCOURSE_SSO_SECRET': settings.discourseSsoSecret,
        'FORUM_URI': settings.forumUri,
        'MEDIA_BUCKET_URI': settings.mediaBucketUri,
        'MEDIA_PROFILE_FOR_AVATARS': settings.mediaProfileForAvatars,
        'SEGMENT_TRACKING_APP_KEY': settings.segmentTrackingAppKey,
        'DEFAULT_PAGE_SIZE': settings.defaultPageSize,
        'MAX_ARRAY_SIZE': settings.maxArraySize,
        'BLIP_DOMAIN_URL': settings.blipDomainUrl,
        'DEFAULT_PORTAL_URL': settings.defaultPortalUrl,
        'BLIP_DESK_URL': settings.blipDeskUrl,
        'BLIP_DESK_URL_TENANT': settings.blipDeskUrlTenant,
        'CERBERUS_URL': settings.cerberusUrl,
        'DEBUG_URL': settings.debugUrl,
        'DEBUG_URL_TENANT': settings.debugUrlTenant,
        'GOOGLE_TAGMANAGER_KEY': settings.googleTagmanagerKey,
        'AI_FRAME_URL': settings.artificialIntelligenceIframeUrl,
        'TENANTS_IFRAME_URL': settings.tenantsIframeUrl,
        'DESK_FRAME_URL': settings.deskIframeUrl,
        'RDSTATION_URL': settings.rdstationUrl,
        'RDSTATION_CLIENT_ID': settings.rdstationClientId,
        'DEFAULT_FRAGMENT_PREFIX': settings.defaultFragmentPrefix,
        'REQUEST_PERMISSION_DESTINATION_EMAIL': settings.requestPermissionDestinationEmail,
        'TEXT': { pageTitle: 'BLiP Painel' },
        'APPLICATION_DEFAULT_IMAGE': 'https://s3-sa-east-1.amazonaws.com/msging.net/iris/Media_ee3797dd-c943-4fd8-bddb-c3cf89d5fbfd',
        'USER_AVATAR_DEFAULT_IMAGE': 'https://s3-sa-east-1.amazonaws.com/msging.net/iris/Media_19a1ae44-ea7a-4245-8e6f-947029410d3b',
        'ACCESS_TOKEN_EXPIRING_MINUTES': settings.accessTokenExpiringMinutes,
        'IDLE_TIME_MINUTES': settings.idleTimeMinutes,
        'NON_EXPIRING_PAGES': settings.nonExpiringPages,
        'BLIP_ACCOUNT_TOGGLE_DEFAULT_VALUE': settings.blipAccountToggleDefaultValue === 'true',
        'NODEENV': settings.nodeEnv,
        'PROXY_BASE_URL': settings.proxyBaseUrl,
        'SENTRY_DSN': settings.sentryDsn,
        'COMMAND_TIMEOUT': settings.commandTimeout,
        'HUBSPOT_SUBMIT_FORMS_URL': settings.hubspotSubmitFormsUrl,
        'UPGRADE_PLAN_HUBSPOT_FORM_ID': settings.upgradePlanHubspotFormId,
        'HUBSPOT_PORTAL_ID': settings.hubspotPortalId,
        'UPGRADE_PLAN_WPP_CONTACT': settings.upgradePlanWppContact,
        'AI_IS_MFE_ENABLED': settings.ai && settings.ai.isReactMicroFrontendEnabled,
        'AI_MFE_SCRIPT_SOURCE': mfesConfigs.ai.uncachedScriptURI,
        'ANALYTICS_MFE_SCRIPT_SOURCE': mfesConfigs.analytics.uncachedScriptURI,
        'GOOD_DATA_MFE_SCRIPT_SOURCE': mfesConfigs.gooddata.uncachedScriptURI,
        'CDP_MFE_SCRIPT_SOURCE': mfesConfigs.cdp.uncachedScriptURI,
        'BLIPSTORE_MFE_SCRIPT_SOURCE': mfesConfigs.blipStore.uncachedScriptURI,
        'BLIP_CONVERSATIONS_INSIGHTS_MFE_SCRIPT_SOURCE': mfesConfigs.blipConversationsInsights.uncachedScriptURI,
        'BUILDER_OBSERVABILITY_MFE_SCRIPT_SOURCE': mfesConfigs.builderObservability.uncachedScriptURI,
        'CHANNELS_GBM_MFE_SCRIPT_SOURCE': mfesConfigs.channelsGbm.uncachedScriptURI,
        'CHANNELS_MESSENGER_MFE_SCRIPT_SOURCE': mfesConfigs.channelsMessenger.uncachedScriptURI,
        'CHANNELS_WHATSAPP_MFE_SCRIPT_SOURCE': mfesConfigs.channelsWhatsApp.uncachedScriptURI,
        'FACEBOOK_DEFAULT_URL': settings.facebookDefaultUrl,
        'HUBSPOT_FRAME_URL': settings.hubspotIframeUrl,
        'DATA_EXTRACTOR_FRAME_URL': settings.dataExtractorFrameUrl,
        'DATA_EXTRACTOR_REDIRECT_URL': settings.dataExtractorRedirectUrl,
        'DATA_EXTRACTOR_REDIRECT_URL_DASHBOARD': settings.dataExtractorRedirectUrlDashboard,
        'HOTJAR': settings.hotjar,
        'MONITORING_SCREEN_REFRESH_PAGE_TIMEOUT': settings.monitoringScreenRefreshPageTimeout,
        'MONITORING_SCREEN_MANUAL_REFRESH_PAGE_INTERVAL': settings.monitoringScreenManualRefreshPageInterval,
        'FACEBOOK_POPUP_CONNECTION_TIME': settings.facebookPopupConnectionTime,
        'SMART_SALES_API_URL': settings.smartSalesApiUrl,
        'BLIP_AI_SUITE_URL': settings.blipAiSuiteUrl,
        'AI_ANSWERS_BASE_URL': settings.aiAnswersBaseUrl,
        'AI_ANSWERS_AUTH_HOST': settings.aiAnswersAuthHost,
        'AI_AGENT_STORAGE_BASE_URL': settings.aiAgentConteinerBaseUrl,
        'ADVANCED_CONFIGURATION_FILTERED_OWNERS': settings.advancedConfigurationFilteredOwners,
        'AI_AGENT_BLIP_CHAT_API_KEY': settings.aiAgentBlipChatApiKey,
        'AI_AGENT_BLIP_CHAT_CUSTOM_URL': settings.aiAgentBlipChatCustomUrl,
        'DEFAULT_CLUSTER_NAME': settings.defaultClusterName,
        'BLIP_PORTAL_URI': settings.BlipPortalUri,
        'BLIP_CALLS_TERMS_OF_USE_URL': settings.blipCallsTermsOfUseUrl,
        'PERSONAL_TENANT_ENABLED': settings.personalTenantEnabled,
        'BLIP_AI_ASSISTANT_API': settings.blipAiAssistantApi,
        'AI_AGENT_IDENTITY_SINGLE_ACTION': settings.aiAgentIdentitySingleAction,
        'BRAIN_BOT_ID': settings.brainBotId,
        'CURRENT_AI_AGENTS_VERSION': settings.currentAiAgentsVersion,
    };

    // Try to use environment variables instead of defined values firstly
    let environmentVariables = {};
    try {
        environmentVariables = ENVIRONMENT_VARIABLES_SERIALIZED; // eslint-disable-line no-undef
    } catch (e) {
        console.error('Error trying to get environment variables'); // eslint-disable-line no-console
    }
    Object.entries(constants).forEach(([key, value]) => {
        module.constant(key, environmentVariables[key] || value);
    });
})();

export default module.name;
